// extracted by mini-css-extract-plugin
export default {"Title":"_Title--BZRg8","Content":"_Content--t6E_R","WarningIcon":"_WarningIcon--FjoWR"};